import {API_ENDPOINT}  from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_API_BASE_URL;

export const  profileApi = async() => {
  const res = await requestInstance.get(
    `${env}${API_ENDPOINT.Profile.api}`
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const  updateProfileApi = async(data) => {
  const res = await requestInstance.patch(
    `${env}${API_ENDPOINT.Profile.api}`, data,
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}
